module.exports = __webpack_public_path__ + "static/media/file-import.ca8759e4.svg";